'use strict';

angular.module('admin.category', [
    'ng-komondor-resource-view',
])

.config(function (resourceStateProvider)
{
    resourceStateProvider
    .state('admin.categories', {
        url: 'categories/{programmeId:[0-9\w-]+}',
        model: 'Category',
        viewOptions: 'categoryViewOptions',
        title: 'Categories',
        modelNameField: 'title',
        edit: {
            templateUrl: 'admin/category/category.edit.html',
            controller: 'EditCtrl',
            defaults: {
                display_order: 1,
            }
        },
        root: {
            resolve: {
                viewOptions: ['categoryViewOptions', '$stateParams', 'stateOptions', 'Programme', '$state', function (viewOptions, $stateParams, stateOptions, Programme, $state)
                {
                    return Programme.find($stateParams.programmeId).then(function (programme)
                    {
                        if (programme) {

                            var breadcrumb = [];

                            breadcrumb.push({
                                name: 'Programmes',
                                go: function ()
                                {
                                    $state.go('admin.programmes');
                                }
                            });

                            breadcrumb.push({
                                name: programme.title,
                            });

                            stateOptions.customBreadcrumb = breadcrumb;

                            stateOptions.edit.defaults.programme_id = programme.id;
                            viewOptions.queryDefaults.where.programme_id = programme.id;
                        }

                        return viewOptions;
                    });
                }]
            }
        }
    });
})

.factory('categoryViewOptions', function (
    extendDeep,
    resourceViewOptions,
    listNameTemplate,
    listView
) {
    return extendDeep(angular.copy(resourceViewOptions), {
        with: [
            'programme',
        ],
        queryDefaults: {
            sort: [
                ['programme_id', 'ASC'],
                ['display_order', 'ASC']
            ],
        },
        list: {
            columns: [
                {
                    label: 'Title',
                    name: 'title',
                    //template: listNameTemplate('title'),
                    sortable: true,
                },
                {
                    label: 'Display Order',
                    name: 'display_order',
                    sortable: true,
                },
                {
                    label: 'Articles',
                    template: '<a ui-sref="admin.articles({categoryId: model.id})">Articles</a>',
                    sortable: false,
                },
                {
                    label: 'Last modified',
                    name: 'updated_at',
                    template: '<span class="no-wrap">{{ model.updated_at | date }}</span>',
                    sortable: true,
                },
            ],
        },
        views: [listView],
        sorts: [
            {
                label: 'Display Order',
                sort: 'display_order asc'
            }
        ],
    });
});
